export const getServerBaseApiUrl = (withoutProxy?: boolean) => {
	if (process.env.NODE_ENV === "development" && !withoutProxy) {
		return "";
	}

	if (process.env.REACT_APP_MODE === "development") {
		return process.env.REACT_APP_DEV_SERVER;
	}

	return process.env.REACT_APP_SERVER;
};
